<template>
    <div>
        <portal to="sticky-header" :order="0">
            <action-mgmt-banner
                :flag="ACTION_MGMT_BANNER_LEGACY_GLOBAL"
                tone="solid"
                badge="Coming Soon"
                cta-label="Find Out More"
                cta-href="https://docs.riskhub.co.uk/docs/product/action-management"
                cta-destination="product documentation"
            >All-in-one Action Management is coming on
                <strong>29th September</strong>.</action-mgmt-banner>
        </portal>

        <portal to="sticky-header" :order="1">
            <b-navbar class="d-none d-md-flex navbar-bold">
                <nav-brand class="py-0 mt-n2"></nav-brand>
                <main-nav class="px-2 main-nav"></main-nav>
                <b-nav class="flex-nowrap align-items-center ml-auto">
                    <support-menu />

                    <user-menu></user-menu>

                  <change-client
                      :defaultText="getClientName()"
                      @change="goToDashboard"
                  />
                </b-nav>
            </b-navbar>
        </portal>

        <b-navbar class="d-flex d-md-none bg-white navbar-bold">
            <nav-brand class="py-0 mt-n2"></nav-brand>
            <b-nav class="flex-nowrap ml-auto">
                <support-menu />

                <user-menu></user-menu>

              <change-client
                  :defaultText="getClientName()"
                  @change="goToDashboard"
              />
            </b-nav>
        </b-navbar>

        <portal to="sticky-header" :order="2">
            <scrollable-widget
                    arrow-bg-color="white"
                    class="tab-nav-wrapper d-block d-md-none pt-1 bg-white">
                <b-navbar class="navbar-wrapper d-flex d-md-none">
                    <main-nav class="navbar-bold"></main-nav>
                </b-navbar>
            </scrollable-widget>
        </portal>

        <portal to="sticky-header" :order="2.5">
            <action-mgmt-banner
                v-if="isRaActionsPage"
                :flag="ACTION_MGMT_BANNER_LEGACY_RA"
                tone="tint"
                cta-label="Switch Portal"
                :cta-href="actionsPortalUrl"
                cta-destination="new client portal"
            >You can now manage your RA actions in the new all in one Action Management
                page in the new OneExperience client portal.</action-mgmt-banner>

            <action-mgmt-banner
                v-if="isClientActionsPage"
                :flag="ACTION_MGMT_BANNER_LEGACY_CLIENT"
                tone="tint"
                cta-label="Switch Portal"
                :cta-href="actionsPortalUrl"
                cta-destination="new client portal"
            >You can now manage your Client actions in the new all in one Action Management
                page in the new OneExperience client portal.</action-mgmt-banner>
        </portal>

        <portal to="sticky-header" :order="3">
            <component :is="subNav" v-if="subNav" class="sub-nav"></component>
        </portal>
    </div>
</template>

<script lang="js">
import ChangeClient from '@/components/User/ChangeClient';
import UserMenu from '@/components/User/UserMenu';
import MainNav from '@/components/Nav/MainNav';
import NavBrand from '@/components/Nav/NavBrand';
import ScrollableWidget from '@/components/Widgets/ScrollableWidget';
import ClientLogo from '@/components/Logo/ClientLogo';
import SupportMenu from '@/components/Nav/SupportMenu.vue';
import ActionMgmtBanner from '@/components/Banner/ActionMgmtBanner';
import {
  ACTION_MGMT_BANNER_LEGACY_GLOBAL,
  ACTION_MGMT_BANNER_LEGACY_RA,
  ACTION_MGMT_BANNER_LEGACY_CLIENT,
} from '@/config/features';


export default {
  name: 'Nav-bar',
  components: {
    SupportMenu,
    NavBrand,
    ChangeClient,
    MainNav,
    UserMenu,
    ScrollableWidget,
    ClientLogo,
    ActionMgmtBanner,
  },
  data() {
    return {
      ACTION_MGMT_BANNER_LEGACY_GLOBAL,
      ACTION_MGMT_BANNER_LEGACY_RA,
      ACTION_MGMT_BANNER_LEGACY_CLIENT,
    };
  },
  computed: {
    // Both signposts point at the same Action Manager page.
    actionsPortalUrl() {
      return `${process.env.VUE_APP_MONOREPO_URL}/actions`;
    },
    // RA Actions lives under /actions, Client Actions under /client-actions — so
    // the RA prefix deliberately does not match the client one.
    isRaActionsPage() {
      return this.$route.path.startsWith('/actions');
    },
    isClientActionsPage() {
      return this.$route.path.startsWith('/client-actions');
    },
    subNav() {
      if (!this.$route.meta.subNav) {
        return false;
      }

      return this.$route.meta.subNav;
    },
  },
  mounted() {
    this.$store.dispatch('fetchUser');
  },
  methods: {
    getClientName() {
      return this.$store.getters.userClientName;
    },
    goToDashboard() {
      window.location.href = '/actions/dashboard';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .navbar-bold {
    font-size: $navbar-font-size;
    font-weight: bold;
  }
  .sub-nav {
    background-color: #F7F9FA;
    font-size: $navbar-font-size;
    padding-left: 2.5em
  }
  .nav-item,
  /deep/ .nav-item:not(.b-nav-dropdown) {
      &:first-child a {
          padding-left: 0;
      }

      a.active {
          &:after {
              content: '';
              border-bottom: 2px solid;
              display: block;
              position: relative;
              height: 2px;
              width: 100%;
              background: black;
              bottom: -11px;
              left: 0;
              padding-right: 0.5rem;
              padding-left: 0.5rem;
          }
      }

      &:not(:last-child) {
          margin-right: map-get($spacers, 4);
      }

      white-space: nowrap;
  }

  /deep/ .dropdown-menu {
      max-height: 90vh;
      overflow-y: auto;

      @include media-breakpoint-down(sm) {
          z-index: $zindex-sticky + 5;
          max-height: 80vh;
      }
  }

  .sub-nav /deep/ {
      .navbar {
          .nav-link {
              padding-top: map_get($spacers, 1);
              padding-bottom: map_get($spacers, 1);
          }
      }

      .has-actions {
          max-width: calc(100vw - 475px);
      }

    .badge-pill {
      border-radius: 3px;
      line-height: 1.1;
    }
  }

  @media screen and (max-width: 767px) {
    .sub-nav {
      padding-left: 0;
    }
  }

</style>
